var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExamDo',{attrs:{"isFile":20},on:{"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"bread",fn:function(){return [_c('div',{staticClass:"bread"},[_c('ExamIndexBread'),_c('span',{staticClass:"slash"},[_vm._v("/")]),_c('span',{staticClass:"current"},[_vm._v("随机练习")])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }